export default function reducer(state = {
    locations: [],
    categories: [],
    strCounts: [],
    max_cost: null,
    tours: [],
    update: false,
    toursArray: false
}, action) {
    switch (action.type) {
        case "STORE_TOUR_FILTERS": {
            return {
                ...state,
                locations: action.list.new_cities,
                categories: action.list.categories,
                strCounts: action.list.str_counts,
                max_cost: action.list.max_cost,
                update: true
            }
        }
        case "STORE_TOUR_DETAILS_UPDATE": {
            return {
                ...state,
                update: action.bool
            }
        }
        case "STORE_TOUR_LISTS": {
            return {
                ...state,
                tours: action.list.tours
            }
        }
        case "CLEAR_TOUR_LISTS": {
            return {
                ...state,
                tours: []
            }
        }
        case "UPDATE_TOUR_LIST_ARRAY": {
            return {
                ...state,
                toursArray: action.bool
            }
        }
        case "UPDATE_MORE_TOUR_LISTS": {
            return {
                ...state,
                tours: [
                    ...state.tours,
                    ...action.list.tours
                ]
            }
        }
        default:
            break;
    }
    return state
}